import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCompanyProfiles } from "../store/slices/companyProfileSlice";

const useSubscriptionLevel = () => {
    const dispatch = useDispatch();
    const { profiles } = useSelector((state) => state.companyProfile);

    const [subscriptionPackage, setSubscriptionPackage] = useState("");

    useEffect(() => {
        dispatch(fetchCompanyProfiles());
    }, [dispatch]);

    useEffect(() => {
        if (profiles?.length > 0) {
            const pkg = profiles[0].subscriptionpackage;
            if (pkg === "CRM" || pkg === "ERP") {
                setSubscriptionPackage(pkg);
            }
        }
    }, [profiles]);

    return subscriptionPackage;     // return value (not JSX)
};

export default useSubscriptionLevel;
